import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getEnvironmentsforUser } from '../api/documentAPI';
import { useManageDocsEnvironmentAtom } from '../atoms/managedocs/useManageDocsEnvironmentAtom';
import { useSelectedEnvTypeAtom } from '../atoms/managedocs/useSelectedEnvTypeAtom';

import useAuth from "../hooks/useAuth";
import DocumentsList from '../components/docs/DocumentsList';
import Uploader from '../components/docs/Uploader';
import EnvironmentsList from '../components/docs/EnvironmentsList';

import '../css/pages/documents.css';

const ManageDocuments = () => {
    
    const { auth } = useAuth();
    const navigate = useNavigate();
    const [t, ] = useTranslation('global');
    const [manageDocsEnvironmentId, setManageDocsEnvironmentId] = useManageDocsEnvironmentAtom();
    const [selectedEnvType, setSelectedEnvType] = useSelectedEnvTypeAtom();

    const handleEnvItemClick = (id, type) => {
        setManageDocsEnvironmentId(id);
        console.log(id + 'id and type ' + type);
        setSelectedEnvType(type);
    }

    const handleGoBack = () => {
        navigate("/");
    };

    useEffect(() => {
        console.log('manageDocsEnvironmentId ', manageDocsEnvironmentId);    
    },[manageDocsEnvironmentId]);

    useEffect(()=> {
        console.log('selectedEnvType', selectedEnvType);
    },[selectedEnvType]);


    const handleDefaultEnvironment = async () => {
        const environments = await getEnvironmentsforUser();
        const manualEnvironments = environments.filter(env => env.Type === "M");

        if (manualEnvironments.length > 0) {
            console.log('setting env : ', manualEnvironments[0].Id);
            setManageDocsEnvironmentId(manualEnvironments[0].Id);
            setSelectedEnvType(manualEnvironments[0].Type); // setting type for uploader check
        } else {
            console.log('envids null ');
        }
    }

    useEffect(() => {
        if (auth.uri === 1) {
            if (manageDocsEnvironmentId === null) {
                handleDefaultEnvironment();
            } else {
                return;
            }
        } else {
            navigate('/Unauthorized'); 
        }
    }, []); 

    return (
        <>
        <div className='documents-wrap'>
            <div className="header-title">
                <h1>{t('manageDocs')}</h1>
            </div>   

            <div className='table-wrapper'>              
                <div className='list-wrapper'>
                    <div id="manage-docs">                      
                    <h3>{t('environments')}</h3>
                        <EnvironmentsList 
                            onEnvItemClick={handleEnvItemClick} 
                        />
                        {manageDocsEnvironmentId && 
                            <DocumentsList 
                                id={manageDocsEnvironmentId} 
                            />
                        }
                    </div>
                </div>
                
                {manageDocsEnvironmentId && selectedEnvType === 'M' && (
                    <div className='upload-wrapper'>
                        <Uploader id={manageDocsEnvironmentId}/> 
                    </div>
                )}
            </div>
            <button className="return-button" onClick={handleGoBack}>{t('return')}</button>
        </div>
        </>        
    );
}

export default ManageDocuments;